import { Grid, Stack } from "@mui/material";
import { InputsOutdatedAlert } from "../../common/alerts/inputsOutdated";
import { useTenant } from "hooks/settings";
import { useSearch } from "contexts/search/SearchContextProvider";
import { ConstraintsAlert } from "../../common/alerts/Constraints";
import { RunConditions, RunConditionsList } from "./RunConditions";
import { InputsSuboptimalAlert } from "components/common/alerts/inputsSuboptimal";
import { useServerIds } from "hooks/search";
import { useIsMobile } from "hooks/useIsMobile";

interface Props {
  children: React.ReactNode;
  isNewSearch: boolean;
  inputsStale: boolean;
  constraintsStale: boolean;
  longestSuboptimalTimeLimit: number | undefined;
  runConditions: RunConditions;
}

export const SearchResultsLayout = ({
  children,
  isNewSearch,
  inputsStale,
  constraintsStale,
  longestSuboptimalTimeLimit,
  runConditions,
}: Props) => {
  const { setSearchId } = useSearch();
  const { searchId: serverSearchId } = useServerIds();
  const tenantName = useTenant();
  const isMobile = useIsMobile();

  return (
    <Grid
      container
      columns={8}
      sx={{ py: isMobile ? 2 : 4, px: isMobile ? 2 : 0 }}
    >
      {!isMobile && <Grid size={{ xs: 1 }} />}
      <Grid size={{ xs: isMobile ? 8 : 6 }}>
        {inputsStale ||
        constraintsStale ||
        isNewSearch ||
        longestSuboptimalTimeLimit !== undefined ||
        !runConditions.areRunConditionsMet ? (
          <Stack sx={{ mb: isMobile ? 3 : 5 }} spacing={2}>
            {constraintsStale && serverSearchId ? (
              <ConstraintsAlert
                searchId={serverSearchId}
                tenantName={tenantName}
                onRefresh={(searchId) => {
                  setSearchId(searchId);
                }}
              />
            ) : null}
            {inputsStale ? (
              <InputsOutdatedAlert />
            ) : longestSuboptimalTimeLimit !== undefined ? (
              <InputsSuboptimalAlert
                previousTimeLimit={longestSuboptimalTimeLimit}
              />
            ) : null}
            {isNewSearch || !runConditions.areRunConditionsMet ? (
              <RunConditionsList />
            ) : null}
          </Stack>
        ) : null}
        {children}
      </Grid>
      {!isMobile && <Grid size={{ xs: 1 }} />}
    </Grid>
  );
};
